var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.126 24.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:props.fill;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "on-off-button",
    transform: "translate(-0.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Path_72",
    "data-name": "Path 72",
    d: "M10.269,11.3V1.883a1.883,1.883,0,0,1,3.766,0V11.3a1.883,1.883,0,0,1-3.766,0Zm9.347-8.537a1.412,1.412,0,0,0-1.749,2.218,9.239,9.239,0,1,1-11.432,0,1.413,1.413,0,1,0-1.75-2.218,12.063,12.063,0,1,0,14.931,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLogout);
export default __webpack_public_path__ + "static/media/icn_logout.544d8e95.svg";
export { ForwardRef as ReactComponent };